var exports = {
  "k": "x2b2fbebb--b5cd50--container",
};

module.exports = exports;
